import { observable, computed, action } from 'mobx';
import { formatRFC3339, parseISO } from 'date-fns';

export const FilterOps = {
  EQ: 'EQ',
  GTE: 'GTE',
  LTE: 'LTE',
  CONTAINS: 'CONTAINS',
};

export const ValueInputType = {
  STRING: 'STRING',
  INT: 'INT',
  FLOAT: 'FLOAT',
  BOOL: 'BOOL',
  DATETIME: 'DATETIME',
};

function valueTypeToValProp(valueType) {
  if (valueType === ValueInputType.DATETIME) {
    return 'valueDateTime'; // due to casing difference of 'Time' in valueDateTime field
  }
  return `value${
    valueType[0].toUpperCase() + valueType.substring(1).toLowerCase()
  }`;
}
export class ValueInput {
  valueString = null;
  valueInt = null;
  valueFloat = null;
  valueBool = null;
  valueDateTime = null;
  valueType = null;

  constructor(value, valueType) {
    this.valueType = valueType;
    this[valueTypeToValProp(valueType)] = value;
  }

  get value() {
    return this[valueTypeToValProp(this.valueType)];
  }

  toJSON() {
    return {
      valueType: this.valueType,
      [valueTypeToValProp(this.valueType)]: this.value,
    };
  }

  toValue = () => {
    if (this.valueType === ValueInputType.DATETIME) {
      return parseISO(this.value);
    }
    return this.value;
  };

  toString = () => {
    /* Convert the ValueInput's value to a value which can be used in a url or API call */
    const value = this[valueTypeToValProp(this.valueType)];
    if (this.valueType === ValueInputType.DATETIME && value instanceof Date) {
      return formatRFC3339(value); // format DateObj to a string? Ideally we'd used nanoseconds since Epoch?
    }
    return value;

    /* if (this.valueType === ValueInputType.INT) {
      return this[valueTypeToValProp(this.valueType)];
    }
    if (this.valueType === ValueInputType.FLOAT) {
      return this[valueTypeToValProp(this.valueType)];
    }
    if (this.valueType === ValueInputType.INT) {
      return this[valueTypeToValProp(str)];
    }   //  true to '1' and false to '0'
    return ''; */
  };
}

export class FilterInput {
  /* This should map closely to the API format. It doesn't exactly but e.g. ValueInputs should be suitable strings etc */
  field;
  value;
  valueObject;
  operator;

  constructor({ field, value, operator, type, valueObject = null }) {
    if (!Object.keys(FilterOps).includes(operator)) {
      throw console.error('Unknown operator');
    }
    this.field = field;
    // encode value according to type
    this.valueObject = valueObject;
    this.value = new ValueInput(value, type);
    this.operator = operator;
  }
}

export class FilterField {
  /*   Each field that can be filtered has a FilterField, which controls the FilterInputs for that field.
  A FilterField can be 'Selected' or not, depending on which it will be included as a filter or not.
  FilterFields should be loaded from url params
  FilterField should be written to url params on done. */

  // fieldName?
  filter;
  name;
  title;
  @observable selected;
  @observable filterInputs = [];

  constructor({
    fieldName,
    fieldTitle,
    filter,
    filterInputs,
    selected = false,
  }) {
    /* Should be initialised based on URL state 
    If inputJoin is 'AND' we add multiple FilterInputs to API queries
    if inputJoin is 'OR' we add multiple ValueInput to the FilterInput */
    this.filter = filter;
    this.filterInputs.push(...filterInputs);
    this.name = fieldName;
    this.selected = selected;
    this.title = fieldTitle;
  }

  @computed get applied() {
    // If this is true then the Filter's filterInputs should be part of the URL we navigate to/
    return this.selected && this.filterInputs.length !== 0;
  }

  @action SetSelected = selected => {
    this.selected = selected;
  };

  @action ToggleSelect = () => {
    if (!this.selected) {
      this.selected = true;
    } else {
      this.selected = false;
    }
    if (this.filter?.OnSelectToggle) {
      this.filter.OnSelectToggle(this.selected);
    }
  };

  @action SetFilterInputs = filterInputs => {
    this.filterInputs.clear();
    this.filterInputs.push(...filterInputs);
    // if the field is selected, these filterInputs should be written to URL state when we apply filters
    // routerStore.router.navigate(routerStore.route.name, params);
  };
}
